import { trending } from "@/mocks/chiGuaData";

const rankColor = (rank: number) =>
  rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700";

export default function TrendingBoard() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-fire-line" aria-hidden="true"></i> HOT
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
              热门瓜榜 · 正在升温
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              基于讨论热度实时刷新，大家都在聊的话题，一个都不让你错过。
            </p>
          </div>
          <span className="text-xs text-foreground-500">热度每 10 分钟更新一次</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 md:grid-cols-2">
          {trending.map((item) => (
            <a
              key={item.rank}
              href="#fresh"
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                  item.rank === 1 ? "bg-accent-500 text-foreground-950" : rankColor(item.rank)
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded bg-secondary-500/15 px-2 py-0.5 text-xs text-secondary-800">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.heat} 热度</span>
                </div>
                <p className="mt-1.5 truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                  {item.title}
                </p>
              </div>
              <i
                className={`shrink-0 text-lg ${
                  item.trend === "up"
                    ? "ri-arrow-up-line text-primary-500"
                    : item.trend === "down"
                      ? "ri-arrow-down-line text-secondary-500"
                      : "ri-loader-3-line text-foreground-400"
                }`}
                aria-hidden="true"
              ></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}